export const defaultTheme = {
    isWhite: true
};

export const scorecardTheme = {
    isBlack: true
};
